import * as React from 'react';
import ParameterResult from "./ParameterResult";
import BestResult from "./BestResult";
import { Parameters, VolumetricParameter, FlowParameter, PFTResults, DiffusingCapacityParameter, PressureParameter, StudyRelevantParameters } from './PFTAPITypes';
import ResultsGroupHeading from './ResultsGroupHeading';

export interface PFTResultParametersProps {
    results: PFTResults;
    isLoading?: boolean;
    isRejected?: boolean;
    showConfiguredParametersOnly?: boolean;
    studyRelevantParameters?: StudyRelevantParameters;
}

export const PFTResultParameters = ({ results, isLoading, isRejected, showConfiguredParametersOnly, studyRelevantParameters }: PFTResultParametersProps) => {
    const renderBestValueResult = (parameter: VolumetricParameter | FlowParameter | DiffusingCapacityParameter | PressureParameter) => {
        const bestValue = results.BestParameters.find(br => br.ParameterType === parameter.ParameterType && br.Units === parameter.Units);

        if (bestValue) {
            return <BestResult isLoading={isLoading} result={bestValue} />
        } else {
            return <td></td>;
        }
    }

    let parameters: Parameters;
    if (showConfiguredParametersOnly) {
        parameters = studyRelevantParameters.AnalysisParameters ?? studyRelevantParameters.DefaultAnalysisParameters;
    } else {
        parameters = results.DisplayParameters;
    }

    return (
        <>
            <ResultsGroupHeading resultsCount={results.TestResults.length} title="Parameters" />
            
            {
                parameters.map(dp => {
                    
                    return (
                        <tr key={`DisplayedParameter${dp.ParameterType}_${dp.Units}`}>
                            <td>{dp.DisplayName}</td>
                            {
                                results.TestResults.sort((a, b) => a.TestNumber - b.TestNumber).map((tr, trIndex) => {
                                    return <ParameterResult 
                                                key={`Result_${dp.ParameterType}_${dp.Units}_${tr.TestId}`} 
                                                results={results.TestResults} 
                                                isRejected={isRejected}
                                                testIndex={trIndex}
                                                testNumber={tr.TestNumber}
                                                parameterId={dp.ParameterType} 
                                                units={dp.Units}
                                                automationSection='parameters'
                                        />
                                })
                            }
                            {renderBestValueResult(dp)}
                        </tr>
                    )
                })
            }
        </>
    );
}
